import React, {PropsWithChildren, useMemo} from "react";
import {AppContent, LayoutContentWrapper, LayoutHorizontalWrapper, LayoutWrapper} from "./styles";
import Toolbar from "../toolbar/Toolbar";
import {useSelector} from "react-redux";
import {selectIsLoggedIn} from "../../store/user";
import {Sidebar} from "../sidebar";
import {selectUserData} from "../../store/user/selectors";
import {Role} from "../../types/Role";

const Layout: React.FC<PropsWithChildren> = props => {
    const isLoggedIn = useSelector(selectIsLoggedIn);
    const user = useSelector(selectUserData);

    const isAdmin = useMemo(() => -1 !== user?.roles?.findIndex(role => role === Role.SuperUser || role === Role.Admin),
        [user]);

    return (<LayoutWrapper id="app-layout">
        <LayoutHorizontalWrapper>
            <LayoutContentWrapper>
                {isLoggedIn && <Toolbar/>}
                <AppContent id="app-content">
                    {props.children}
                </AppContent>
            </LayoutContentWrapper>
            {isAdmin && <Sidebar/>}
        </LayoutHorizontalWrapper>
    </LayoutWrapper>);
}

export default Layout;
